<template>
  <div id="app">
    <app-header class="header" />
    <div v-if="flashMessage.message"
      :class="`alert ${flashMessage.type}`" v-html="$t(flashMessage.message, flashMessage.i18nArgs)"></div>
    <div class="main-container">
      <router-view/>
    </div>
    <app-footer/>
    <footer class="footer">
      <!--<cookie-law theme="cookie-law-theme" v-on:accept="enableGoogleAnalytics()" ref="gdpr-notice">
        <div slot-scope="props" style="display: inline-block; width: 100%">
          <p style="float: left">
            Este sitio web utiliza cookies para poder mejorar la experiencia de usuario.
            <router-link to="legal-notes">Haz click aquí para saber más</router-link>
          </p>
          <div style="float: right">      
            <button class="btn btn-danger" @click="props.close"><span>Cerrar</span></button>
            <button class="btn btn-secondary" style="margin-right: 5px;" @click="props.accept"><span>Aceptar</span></button>    
          </div>
        </div>
      </cookie-law>-->
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { bootstrap } from 'vue-gtag';
import Header from './components/header/header.vue';
import Footer from './components/footer.vue';

export default {
  name: 'app',
  components: {
    'app-header': Header,
    'app-footer': Footer,
  },
  computed: {
    ...mapGetters('usersModule', ['user']),
    ...mapState({
      flashMessage: state => state.flashMessages,
    }),
  },
  mounted() {
    const cookies_accepted = localStorage.getItem('cookie:accepted');
    if (!cookies_accepted) {
      // this.$refs['gdpr-notice'].open();
    }
    this.indexNotifications();

    this.enableGoogleAnalytics();
  },
  methods: {
    ...mapActions({
      clearFlashMessage: 'flashMessages/clear',
    }),
    ...mapActions('procurementNotificationsModule', {
      indexNotifications: 'indexNotifications',
    }),
    enableGoogleAnalytics() {
      bootstrap();
    },
  },
};

</script>


<style>

#app {
  text-align: center;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.main-container{
  padding: 40px;
  min-height: 85vh;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.Cookie--cookie-law-theme {
      background: #343A40;
      color: white;
      padding: 1.250em;
}

</style>
